const __WEBPACK_NAMESPACE_OBJECT__ = flarum.core.compat['flags/forum/components/FlagPostModal'];